import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { createTheme, ThemeProvider, useTheme } from "@mui/material/styles";
import "./MainPageTypography.css";

// Explicitly include site pages and editable forms. Document preview routes,
// checkout, unknown routes, and the separate PDF root keep their original styles.
const MAIN_PAGE_PATHS = new Set([
  "/", "/home", "/clients", "/projects", "/payments", "/records",
  "/pricing", "/usermanagement", "/templates", "/login", "/unauthorized",
  "/invoice",
]);

export default function MainPageTypography({
  children,
}: {
  children: React.ReactNode;
}) {
  const { pathname } = useLocation();
  const normalizedPath = pathname.replace(/\/+$/, "") || "/";
  const parentTheme = useTheme();
  const formTheme = useMemo(() => createTheme(parentTheme, {
    components: {
      MuiDialog: { defaultProps: { className: "site-typography-portal" } },
      MuiMenu: { defaultProps: { className: "site-typography-portal" } },
      MuiPopover: { defaultProps: { className: "site-typography-portal" } },
      MuiDrawer: { defaultProps: { className: "site-typography-portal" } },
    },
  }), [parentTheme]);

  const isSitePage = MAIN_PAGE_PATHS.has(normalizedPath) ||
    /^\/invoice\/[^/]+\/[^/]+$/.test(normalizedPath) ||
    /^\/register\/[^/]+$/.test(normalizedPath) ||
    /^\/project-inquiry-response\/[^/]+\/[^/]+\/[^/]+\/[^/]+$/.test(normalizedPath);

  if (!isSitePage) {
    return <>{children}</>;
  }

  return (
    <ThemeProvider theme={formTheme}>
      <div className="main-page-typography">{children}</div>
    </ThemeProvider>
  );
}
